import React from 'react';

export default function VideoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M9.12521 7.18369C8.62521 6.8948 8 7.25563 8 7.83309V12.1668C8 12.7443 8.62522 13.1051 9.12521 12.8162L13.2501 10.4329C13.4048 10.3436 13.5 10.1785 13.5 9.99996C13.5 9.82139 13.4048 9.65637 13.2501 9.56703L9.12521 7.18369ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3Z"
        fill="#262626"
      />
    </svg>
  );
}
